export interface PrequalificationReportDocument {
  documentType: string;
  documentName: string;
  documentNumber: string;
}
